// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import styles from './styles.js';

class Button extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    upperCase: PropTypes.bool,
    text: PropTypes.string,
    style: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
    isMainButton: PropTypes.bool,
    outlined: PropTypes.bool,
    light: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    upperCase: true,
    text: 'It is text',
    style: null,
    onPress: null,
    type: 'button',
    isMainButton: false,
    outlined: false,
    light: false,
  };

  render() {
    const {
      classes,
      text,
      upperCase,
      style,
      type,
      isMainButton,
      onPress,
      outlined,
      light,
    } = this.props;
    const renderText = upperCase ? text.toUpperCase() : text;

    return (
      <button
        type={type}
        onClick={onPress}
        className={classNames(style,
          light && classes.light,
          outlined && classes.outlined,
          !isMainButton ? classes.noMainButton : classes.mainButton, classes.mainContainer)}
      >
        <span>{renderText}</span>
      </button>
    );
  }
}

export default withStyles(styles)(Button);
